import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于春色影视，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-6 border border-background-200/60"
            >
              <h3 className="text-foreground-900 font-semibold text-base mb-3 flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex-shrink-0 mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}